module.exports = __webpack_public_path__ + "img/android5.4db0e21c.jpeg";